import React from 'react';
import PropTypes from 'prop-types';
import { isArray } from 'lodash';

var withErrors = require('./../../utils/mixins/withError');
var helper = {
  Ui: require('../ui-helper'),
  Bootstrap: require('../bootstrap-helper')
};
var constants = require('../../constants');

var ImageUploader = React.createClass({

  IMAGE_CROP: "ImageCrop",
  DROPZONE: "Dropzone",
  TEMP_IMAGE_NAME: "temp_image",

  propTypes: {
    onImageUpload: React.PropTypes.func,
    onCancelUpload: React.PropTypes.func,
    imageType: React.PropTypes.string,
    imageQuality: React.PropTypes.number,
    accept: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  },

  getDefaultProps(){
    return {
      imageType: 'image/jpeg',
      imageQuality: 0.95,
      uploadError: null,
      error: null,
      accept: constants.MimeType.IMAGE,
    }
  },

  getInitialState(){
    var {error} = this.props;
    return {
      file: null,
      uploadProgress: null,
      uploadError: error,
      imageUrl: null
    }
  },

  getAcceptedExts() {
    const { accept } = this.props;
    return isArray(accept)
      ? accept.join(',')
      : accept;
  },

  componentWillReceiveProps(nextProps){
    if (this.state.error != nextProps.error) {
      this.setState({uploadError: nextProps.error});
    }
  },

  render(){
    return <div className="image-upload-control">
      {this._renderError()}

      <helper.Ui.DropZone multiple={false} onDrop={this._onDropFile}
                          accept={this.getAcceptedExts()} ref={this.DROPZONE}>
        {!!this.state.file &&
        <ReactImageCrop
          ref={this.IMAGE_CROP}
          src={this.state.file.preview}
          style={{height: 400, width: '100%'}}
          aspectRatio={1}
          guides={false}
          dragMode='crop'
          viewMode={1}
        />
        }
      </helper.Ui.DropZone>

      <helper.Ui.ProgressBar
        percent={this.state.uploadProgress}
        type="progress-micro"
      />

      <div className="btn-block">
        {this._renderActions()}
      </div>

      <div className="form-actions">
        {this._renderControls()}
      </div>

    </div>;
  },

  _renderControls(){
    return (
      <helper.Bootstrap.Row>
        <div className='col-md-12'>
          <a className="btn btn-primary"
             onClick={this.props.onCancelUpload}><span>{i18n.t("Cancel", {
            context: 'button',
            ns: 'main'
          })}</span></a>&nbsp;
          {!!this.state.file &&
          <a key="upload-control" className="btn btn-primary"
             onClick={this._uploadImage}><span>{i18n.t("Upload", {
            context: 'button',
            ns: 'main'
          })}</span></a>
          }&nbsp;
        </div>
      </helper.Bootstrap.Row>
    )
  },

  _renderActions(){

    return (
      <helper.Bootstrap.Row>
        <div className='col-md-12 text-left'>
          <a className="btn btn-primary btn-xs"
             onClick={this._browseFile}><span>{i18n.t("Browse", {
            context: 'button',
            ns: 'main'
          })}</span></a>
          &nbsp;

        </div>
      </helper.Bootstrap.Row>
    );
  },

  _renderError(){
    var {uploadError} = this.state;
    if (!uploadError) return null;

    return <helper.Ui.ErrorMessage errorMessage={uploadError}/>;
  },

  _onDropFile(files, rejectedFiles){
    let uploadError = null;

    if (rejectedFiles.length) {
      uploadError = `File(s) ${rejectedFiles.map(file => file.name).join(', ')} have unsupported format`;
    }

    if (files.length > 0) {
      this.setState({
        file: files[0],
        uploadProgress: 0,
        uploadError,
        imageUrl: null,
      });
    } else {
      this.setState({
        uploadError,
      });
    }
  },

  _onUploadProgress(progressPercentage){
    this.setState({uploadProgress: progressPercentage});
  },

  _onCancelUpload(){
    this.setState({
      uploadProgress: 0,
      uploadError: null
    });
  },

  _onUploadError(err){
    this.setState({
      uploadError: err.message,
      uploadProgress: 0
    });
  },

  _getImageName(){
    var {imageType} = this.props;
    var ext = imageType.split('/');
    return this.TEMP_IMAGE_NAME + '.' + ext.pop();
  },

  _onImageCreated(image){
    var {onImageUpload} = this.props;

    if (typeof onImageUpload != "function") {
      return;
    }

    this.setState({
      uploadProgress: 0,
      uploadError: null
    });

    image.name = this._getImageName();

    onImageUpload(image, this._onUploadProgress);
  },

  _removeImage(){
    this.setState({
      file: null,
      uploadProgress: 0,
      uploadError: null,
      imageUrl: null
    });
  },

  _browseFile(e){
    this.refs[this.DROPZONE].openFileDialog();
  },

  _uploadImage(){
    this.refs[this.IMAGE_CROP].getCroppedCanvas({fillColor: '#FFFFFF'})
      .toBlob(this._onImageCreated, this.props.imageType, this.props.imageQuality);
  }

});


module.exports = withErrors(ImageUploader);
